<template>
  <div class="section-panel text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t(`${title}.title`)}}</h3>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div v-if="active=='projects'">
              <investments-table :title="$t('settings.projects')" :filters="filters">
              </investments-table>
            </div>

            <div v-if="active=='users'">
              <investments-table :title="$t('settings.users')" :filters="filters">
              </investments-table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button, Alert, Switch, Checkbox } from '@/components';
import { MessageBox, Message } from 'element-ui';
import InvestmentsTable from '../../pages/components/InvestmentsTable.vue';

export default {
  name: 'portfolio',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,  
    [Switch.name]: Switch,
    Alert,
    InvestmentsTable
  },
  mounted() {
    if (this.$route.query.active) {
      this.setItem(this.$route.query.active)
    }
  },
  data() {
    return {
      active: 'projects',
      title: (this.$store.state && this.$store.state.user.role) ? (this.$store.state.user.role == 'USER' ? 'investment' : 'portfolio') : 'investment',
      filters: null
    }
  },
  methods: {
    setItem (item) {
      this.active = item
    },
    isActive: function (l) {
      return this.active === l
    }
  }
};
</script>
<style>
</style>